import React, { useState, useContext } from 'react'
import { t } from '@lingui/macro'
import GeneralRemoveModal from '../../../components/common/general-remove-modal/GeneralRemoveModal'
import IconClose from '../../../components/common/icon/IconClose'
import { IconArrowUp } from '../../../components/common/icon/IconArrowUp'
import { IconArrowDown } from '../../../components/common/icon/IconArrowDown'

import { useTopicForEditQuery } from '../../topic-edit-page/TopicEditPage'

import TopicElementsManager from '../../topic-edit-page/TopicElementsManager'
import './EditElementWrapper.less'
import { TopicElementModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { TopicEditingContext } from '../../topic-edit-page/TopicEditContext'
import { Box } from 'front-end/src/components'
import { css } from '@emotion/react'

interface IProps {
  element: TopicElementModelAsEditor
  isMultiPage?: boolean
  isMediaElement?: boolean
}

export const EditElementWrapper: React.FC<IProps> = ({
  isMediaElement,
  element,
  isMultiPage,
  children
}) => {
  const [removalModalVisible, showRemovalModal] = useState(false)
  const { topic } = useContext(TopicEditingContext)
  const { refetch } = useTopicForEditQuery()

  if (isMultiPage) {
    return (
      <Box
        className="EditElementWrapper"
        css={css`
          position: ${isMediaElement ? 'inherit' : 'unset'};
        `}
      >
        {children}
      </Box>
    )
  }
  const { draftVersion } = topic
  if (!draftVersion) {
    return null
  }

  return (
    <Box className="EditElementWrapper">
      <GeneralRemoveModal
        show={removalModalVisible}
        entityName={t`element`}
        confirmButton={t`Delete`}
        onDeleted={() => showRemovalModal(false)}
        onCanceled={() => showRemovalModal(false)}
        operation={async () => {
          await TopicElementsManager.onRemove(topic, element)
          await refetch()
        }}
      />
      {children}
      <Box className="EditElementWrapper__actions">
        <IconClose onClick={() => showRemovalModal(true)} />
        {TopicElementsManager.canMoveUp(topic, element) && (
          <IconArrowUp
            boxSize="20px"
            onClick={async () => {
              await TopicElementsManager.onMoveUp(topic, element)
              await refetch()
            }}
          />
        )}
        {TopicElementsManager.canMoveDown(topic, element) && (
          <IconArrowDown
            boxSize="20px"
            onClick={async () => {
              await TopicElementsManager.onMoveDown(topic, element)
              await refetch()
            }}
          />
        )}
      </Box>
    </Box>
  )
}
